import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import Datetime from "react-datetime";

class DateRange extends React.Component {
  static get displayName() {
    return "DateRange";
  }

  static get propTypes() {
    return {
      start: PropTypes.string,
      end: PropTypes.string,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      endDate: moment().subtract(1, "days"),
      startDate: moment().subtract(7, "days"),
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.start !== this.props.start ||
      prevProps.end !== this.props.end
    ) {
      this._setDates(this.props);
    }
  }

  componentDidMount() {
    this._setDates(this.props);
  }

  _setDates(props) {
    if (props.start && props.end) {
      this.setState({
        startDate: moment(props.start),
        endDate: moment(props.end),
      });
    }
  }

  get() {
    return {
      end: this.state.endDate,
      start: this.state.startDate,
    };
  }

  _onDataChange(start, end) {
    start = start || this.state.startDate;
    end = end || this.state.endDate;

    if (start.isAfter(end)) {
      [start, end] = [end, start];
    }

    this.setState({
      endDate: end,
      startDate: start,
    });
  }

  onEndChange(dt) {
    this._onDataChange(undefined, dt);
  }

  onStartChange(dt) {
    this._onDataChange(dt);
  }

  isValidDate(date) {
    return moment().add(-1, "days").isAfter(date);
  }

  isValidStartDate(date) {
    return this.isValidDate(date) && this.state.endDate.isAfter(date);
  }

  isValidEndDate(date) {
    return this.isValidDate(date) && this.state.startDate.isBefore(date);
  }

  render() {
    const { startDate, endDate } = this.state;
    return (
      <div className="date-range-container">
        <Datetime
          value={startDate}
          inputProps={{ className: "form-control report-range-datepicker" }}
          isValidDate={this.isValidStartDate.bind(this)}
          onChange={this.onStartChange.bind(this)}
          timeFormat={false}
        />
        <Datetime
          value={endDate}
          inputProps={{ className: "form-control report-range-datepicker" }}
          isValidDate={this.isValidEndDate.bind(this)}
          onChange={this.onEndChange.bind(this)}
          timeFormat={false}
        />
      </div>
    );
  }
}

module.exports = DateRange;
